import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { IncidentType } from "../_types/incident-type";

@Injectable({
    providedIn: 'root',
})
export class IncidentsTypesService extends Service<IncidentType> {
    public override type = 'incidentTypes';
    public override url = 'attendance/incidentsTypes';
}
